// The query Market Overview needs on the route to render its default report.
//
// MarketOverview.vue bounces to /list-search when the route carries no query at
// all, and buildParams() there defaults city[], type[] and status[] itself — so
// only these three keys have to be on the URL. ListSearch.vue's onSubmit()
// builds the same shape from the search form (unittype[] picks up the user's
// commercial-type selections on top of the segment guts); this constant is the
// no-input version, for links that open the report directly.
export const MARKET_OVERVIEW_DEFAULT_QUERY = {
  // Strata (2952) + rental (2954) segments, plus the 2975 gut always sent with them.
  "unittype[]": [2952, 2954, 2975],
  report: ["true"],
  region: "british-columbia",
};

export const MARKET_OVERVIEW_DEFAULT_ROUTE = {
  name: "market-overview",
  query: MARKET_OVERVIEW_DEFAULT_QUERY,
};
